import * as React from 'react';
import { Redirect } from 'react-router-dom';
import Modal from 'react-awesome-modal';
import { toast, ToastContainer } from 'react-toastify';

import withServices from '../../../../HOCs/withServices';
import NavBar from '../../../../components/CustomNav/CustomNav.Component';
import { Container, FormWrapper, Row, ContentWrapper, ContentHeading, ContentBody, InputWrapper, CtaWrapper, Disclaimer, ModalContainer, FeedbackP, InputItemsRow } from '../../Common/Common.styles';
import DatePicker from '../../../../components/DatePicker/DatePickerComponent';
// import logo from '../../../../assets/images/plex_new.png';

interface IProps {
    services?: any;
    history?: any;
}

class StudentRegistration extends React.Component<IProps> {
    public state = {
        username: '',
        password: '',
        confirmpassword: '',
        email: '',
        phone: '',
        age: '',
        firstName: '',
        lastName: '',
        onboardingQuestions: [],
        signUpSuccess: false,
        feedbackOpen: false, // toggles modal
        feedbackLoaded: false,
        dateObj: null
    }
    private ls = window.localStorage;

    constructor(props) {
        super(props);
        this.navigate = this.navigate.bind(this);
        this.registerStudent = this.registerStudent.bind(this);
        this.handleChange = this.handleChange.bind(this);
    }

    public async componentDidMount() {
        const {
            history,
            services: {
                isUserLoggedIn,
                parentsAPI,
                currentBaseUrl,
                currentDesignation,
                isUserUpgraded }
        } = this.props;

        if (isUserLoggedIn) {
            if (isUserUpgraded) {
                this.navigate('students/home')
            }
        }

        const onboardingQuestions = this.ls.getItem('onboardingQuestions');
        if (onboardingQuestions === null) {
            console.log("No onboarding questions answered");
        } else {
            const questions = JSON.parse(onboardingQuestions);
            this.setState({ onboardingQuestions: questions });
        }
    }

    public handleChange(event) {
        const currentField = event.target.dataset.arg;
        this.state[currentField] = event.target.value;
        console.info(this.state[currentField]);
    }

    public ageChangeHandler = (dateObj) => {
    const age = `${dateObj.year}-${dateObj.month}-${dateObj.day}`;
        this.setState({dateObj, age});
    }

    public navigate(destination) {
        const { history } = this.props;
        history.push(destination);
    }
    public async registerStudent(event) {
        const { firstName, lastName, email, phone, age, password, confirmpassword, onboardingQuestions } = this.state;
        const { services: { fixturesAPI, baseAPI } } = this.props;
        // handle form submission
        event.preventDefault();
        const payload = {
            // firstName,
            // lastName,
            childdob: age,
            email,
            onboardingQuestions,            
            password,
            phone
        }
        console.info("Payload: " + JSON.stringify(payload, null, 5));
        // post data and navigate on success
        const signUp = await baseAPI.post(`/users/registration/students`, JSON.stringify(payload), true);
        console.log("Sigup: " + JSON.stringify(signUp, null, 2))
        if(signUp.ok) {
            toast.success("Account Created Successfully");
            setTimeout( () => {this.props.history.replace('/login')}, 2000)
            
        }else {
            toast.error("Account Creation Failed! Check your Details!");
        }
    }

    public closeModal = (status) => {
        if (status === true) {
            // sign up was successful, go to login
            this.props.history.push('/login');
        }
        this.setState({ feedbackOpen: false });
    }

    public renderFeedbackModal = () => {
        const { feedbackOpen, signUpSuccess, feedbackLoaded } = this.state;
        if (feedbackLoaded) {
            let content = (<FeedbackP success={signUpSuccess}><span>Signed Up Successfully! </span><br /> Check your email for confirmation!</FeedbackP>)
            if (!signUpSuccess) {
                content = (<FeedbackP success={signUpSuccess}><span>Sign Up Failed! </span><br /> check your details and try again!</FeedbackP>)
            }
            return (
                <Modal
                    visible={feedbackOpen}
                    effect="fadeInUp"
                    onClickAway={this.closeModal.bind(this, signUpSuccess)}
                >
                    <ModalContainer>
                        {content}
                    </ModalContainer>
                </Modal>

            )
        } else {
            console.log("no feedback yet");
            return;
        }
    }

    public render() {
        return (
            <Container>
                <NavBar />
                <ToastContainer/>
                {this.renderFeedbackModal()}
                <Row>
                    <ContentWrapper>
                        <ContentHeading>GET STARTED</ContentHeading>
                        <ContentBody>
                            Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed
                            diam nonummy nibh euismod tincidunt ut laoreet dolore
                            magna aliquam erat volutpat. Ut wisi enim ad minim
                        </ContentBody>
                    </ContentWrapper>

                    <FormWrapper>
                        <form onSubmit={this.registerStudent}>
                            {/* <InputWrapper>
                                <p>1. What are your names? </p>
                                <InputItemsRow>
                                    <input
                                        className="custom-textfield checkout-input"
                                        type="text"
                                        name="firstName"
                                        id="first-name"
                                        placeholder="First Name"
                                        onChange={this.handleChange}
                                        required={true}
                                        data-arg="firstName"
                                    />

                                    <input
                                        className="custom-textfield checkout-input"
                                        type="text"
                                        name="lastName"
                                        id="last-name"
                                        placeholder="Last Name"
                                        onChange={this.handleChange}
                                        required={true}
                                        data-arg="lastName"
                                    /></InputItemsRow>
                            </InputWrapper> */}


                            <InputWrapper>
                                <p>1. What is your email address?</p>
                                <input
                                    type="email"
                                    id="email"
                                    className="custom-textfield"
                                    placeholder="Email"
                                    required={true}
                                    data-arg="email"
                                    onChange={this.handleChange}
                                />
                            </InputWrapper>
                            <InputWrapper>
                                <p>2. What is your phone number?</p>

                                <input
                                    type="text"
                                    id="phone"
                                    className="custom-textfield"
                                    placeholder="Phone Number"
                                    required={true}
                                    data-arg="phone"
                                    onChange={this.handleChange}
                                />
                            </InputWrapper>
                            <InputWrapper>
                                <p>3. What's your birthday?</p>
                                <DatePicker 
                                    value = {this.state.dateObj}
                                    onChange = {this.ageChangeHandler}
                                />
                                {/* <input
                                    type="date"
                                    id="age"
                                    className="custom-datepicker"
                                    placeholder="My Child's Age"
                                    required={true}
                                    data-arg="age"
                                    onChange={this.handleChange}
                                /> */}
                            </InputWrapper>

                            <InputWrapper>
                                <p>4. Please enter a password</p>
                                <input
                                    type="password"
                                    id="password"
                                    className="custom-textfield"
                                    placeholder="Password"
                                    required={true}
                                    data-arg="password"
                                    onChange={this.handleChange}
                                />
                            </InputWrapper>

                            <CtaWrapper>
                                <button className="blue-button register-parent" type="submit">Complete Signup</button>
                                {/* <button className="blue-button register-parent" onClick={this.toCalendly}>Book a Call</button> */}
                            </CtaWrapper>

                            <Disclaimer>
                                By signing up you agree to our <a href="https://myperformancelearning.com/terms-of-service/" target='_blank'>Terms and Conditions</a>, <a href="https://myperformancelearning.com/privacy-policy/" target='_blank'>Privacy Policy</a> and <a href="http://myperformancelearning.com/cookie-policy/" target="_blank" >Cookie Policy</a>
                            </Disclaimer>
                        </form>
                    </FormWrapper>
                </Row>
            </Container>
        )
    }
}

export default withServices(StudentRegistration);


// WEBPACK FOOTER //
// ./src/pages/Onboard/Student/Registration/StudentRegistration.Component.tsx